import React from "react";
import {
  Datagrid,
  TextField,
  List,
  ReferenceField,
  ShowButton,
} from "react-admin";
import AssociateButton from "../AssociateButton";

const PanelList = ({ orgId, filter, can_remove, can_add }) => {
  return (
    <List title="" basePath={"/panels"} resource="panels" filter={filter}
    component={"div"} >
      <Datagrid>
        <TextField source="uid" />
        <TextField source="access_code" />
        <TextField source="installer_code" />
        <TextField source="notes" />
        <ShowButton />
      </Datagrid>
    </List>
  );
};

export default PanelList;